<div [matTooltip]="tooltip" *ngIf="toggleShowBtn">
  <button
    [type]="typeBtn"
    (click)="click()"
    mat-raised-button
    [color]="matColor"
    class="button-with-progress theme-dark-mat-btn"
    [disabled]="loading$ || isDisabled">
    <span [class.spinner]="loading$">
      {{ label }}
    </span>
  </button>
</div>
